import React, {useState, useCallback} from 'react';
import PropTypes from 'prop-types';
import ModalPreviewNavigation from '@adsk/bim360-matrix-react-modal-preview-navigation';
import {screenType} from '../../constants/analytics';
import {issuesSortOrderArrayType} from '../../constants/proptype-validation';
import {CurrentIssuePreviewPopupContext} from '../issues/useCurrentIssuePreviewPopup';
import IssuePreview from '../issues/IssuePreview';

const IssuePreviewModal = ({
  isModalOpen,
  container,
  issueId,
  issuesSortOrder,
  attachmentGalleryIsOpen,
  isIssuesCollectionLoading,
  changePreviewId,
  onClose
}) => {
  const [currentIssuePreviewPopup, setCurrentIssuePreviewPopup] = useState(null);
  const [isKeyboardDisabled, setIsKeyboardDisabled] = useState(false);
  const keyboard = !isKeyboardDisabled && !attachmentGalleryIsOpen;
  const navigationEnabled =
    currentIssuePreviewPopup === null && !isIssuesCollectionLoading && !!(issuesSortOrder && changePreviewId);

  const onPreviewNext = useCallback(() => {
    const length = issuesSortOrder.length;
    let index = issuesSortOrder.indexOf(issueId);
    index = index === length - 1 ? 0 : index + 1;
    return changePreviewId(issuesSortOrder[index]);
  }, [changePreviewId, issueId, issuesSortOrder]);

  const onPreviewPrev = useCallback(() => {
    let index = issuesSortOrder.indexOf(issueId);
    index = index === 0 ? issuesSortOrder.length - 1 : index - 1;
    return changePreviewId(issuesSortOrder[index]);
  }, [changePreviewId, issueId, issuesSortOrder]);

  const onModalHide = useCallback(() => {
    setIsKeyboardDisabled(false);
    onClose();
  }, [onClose]);

  const modalProps = {
    bsClass: 'IssuePreviewModal',
    show: isModalOpen,
    backdrop: 'static',
    onHide: onModalHide,
    onExited: () => {},
    bsSize: 'large',
    container,
    keyboard
  };

  return (
    <ModalPreviewNavigation
      bootstrapModal={modalProps}
      id="issuePreviewContainer"
      navigationEnabled={navigationEnabled}
      next={onPreviewNext}
      previous={onPreviewPrev}
    >
      <CurrentIssuePreviewPopupContext.Provider value={{currentIssuePreviewPopup, setCurrentIssuePreviewPopup}}>
        <IssuePreview container={container} origin={screenType.PROJECT} disableKeyboard={setIsKeyboardDisabled} />
      </CurrentIssuePreviewPopupContext.Provider>
    </ModalPreviewNavigation>
  );
};

IssuePreviewModal.displayName = 'IssuePreviewModal';

IssuePreviewModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  container: PropTypes.object,
  issueId: PropTypes.string,
  issuesSortOrder: issuesSortOrderArrayType,
  attachmentGalleryIsOpen: PropTypes.bool.isRequired,
  isIssuesCollectionLoading: PropTypes.bool.isRequired,
  changePreviewId: PropTypes.func,
  onClose: PropTypes.func.isRequired
};

export default IssuePreviewModal;
